/**
 * @fileoverview Hook responsável por sincronizar eventos do construtor de fluxos via socket.
 */

import { useState, useEffect, useRef } from "react";
import openSocket from "../../../../services/socket-io";

/**
 * Hook que escuta eventos de execucao de workflow via Socket.IO.
 * Retorna logs de execucao, status de nodes, e controle do painel de logs.
 */
var useWorkflowSocket = function (workflowId) {
  var executionLogsState = useState([]);
  var executionLogs = executionLogsState[0];
  var setExecutionLogs = executionLogsState[1];

  var logPanelOpenState = useState(false);
  var logPanelOpen = logPanelOpenState[0];
  var setLogPanelOpen = logPanelOpenState[1];

  var nodeExecutionState = useState({});
  var nodeExecution = nodeExecutionState[0];
  var setNodeExecution = nodeExecutionState[1];

  // Track current execution to know when to reset
  var currentExecRef = useRef(null);

  useEffect(function () {
    var companyId = localStorage.getItem("companyId");
    if (!companyId || !workflowId) return;

    var socket = openSocket();

    var handleExecution = function (data) {
      if (String(data.workflowId) !== String(workflowId)) return;

      // Primeiro "running" de uma nova execucao: limpar status anteriores
      if (data.status === "running" && !currentExecRef.current) {
        currentExecRef.current = Date.now();
        setNodeExecution({});
      }

      // Quando todos os nodes terminam (ultimo completed/error), marcar execucao como encerrada
      // para que a proxima running limpe tudo
      if (data.status === "completed" || data.status === "error") {
        // Usar timeout pequeno para agrupar eventos rapidos
        setTimeout(function () {
          currentExecRef.current = null;
        }, 500);
      }

      // Atualizar status visual do node (mantém indefinidamente)
      setNodeExecution(function (prev) {
        var next = Object.assign({}, prev);
        next[data.nodeId] = data.status;
        return next;
      });

      // Adicionar ao log
      var logEntry = {
        id: Date.now() + "-" + Math.random().toString(36).substr(2, 6),
        nodeId: data.nodeId,
        status: data.status,
        details: data.details || {},
        timestamp: data.timestamp || Date.now(),
      };
      setExecutionLogs(function (prev) { return [logEntry].concat(prev).slice(0, 200); });

      // Auto-abrir painel no primeiro evento running
      if (data.status === "running") {
        setLogPanelOpen(true);
      }
    };

    socket.on("company-" + companyId + "-workflowExecution", handleExecution);

    return function () {
      socket.off("company-" + companyId + "-workflowExecution", handleExecution);
    };
  }, [workflowId]);

  return {
    executionLogs: executionLogs,
    logPanelOpen: logPanelOpen,
    setLogPanelOpen: setLogPanelOpen,
    nodeExecution: nodeExecution,
  };
};

export default useWorkflowSocket;
